import axios from 'axios';
const API_URL = process.env.REACT_APP_API;

export async function getAllCuentas() {
  const response = await axios.get(
    `${API_URL}catalogos/account?limit=1000&page=1`
  );
  const data = response.data.doc.data;
  return data;
}

export async function getBalanceYear() {
  const response = await axios.get(`${API_URL}operation/activity/current/year`);
  const data = response.data.doc.data;
  return data;
}

export async function getBalanceMonth() {
  const response = await axios.get(
    `${API_URL}operation/activity/current/month`
  );
  const data = response.data.doc.data;
  return data;
}

export async function getBalanceWeek() {
  const response = await axios.get(`${API_URL}operation/activity/current/week`);
  const data = response.data.doc.data;
  return data;
}
